export default "<app-pilot></app-pilot>\n<app-exporter></app-exporter>\n<div class=\"container\">\n  <app-user-search></app-user-search>\n</div>\n"